import React, { useContext } from "react";
import { CreateArtifactContext } from "../context/CreateArtifactContext";
import { NavigationProps } from "../context/NavigationContext";
import { isStringEmpty } from "../utils/stringFunctions";
import ActionPopup from "./ActionPopup";

// type Props = {
//   enableLink: boolean;
//   to: string;
//   children: React.ReactNode;
// };

const ContainerNavigation = ({
  backArrow,
  title,
  buttonTitle,
  subtitle,
  userActions,
  icon,
  enableLink,
  onBack,
  onClose,
  onSearch,
  onFilter,
  onNext,
  onEdit,
  getActionItems,
  onActionItemSelect,
  FilterButton,
  artifactStatus,
}: NavigationProps) => {
  return (
    <>
      <div className="flex flex-row h-[50px] my-3 w-full justify-between">
        <div className="flex flex-row float-left text-lg font-bold">
          {backArrow ? (
            <button
              onClick={() => (typeof onBack === "function" ? onBack() : window.history.back())} // Use history object to navigate back
              className="flex items-start" // Ensuring the button content is also centered
            >
              <img src={`/icons/back.png`} alt="Back" className="w-6 h-6" />
            </button>
          ) : (
            <></>
          )}
          <div className="flex flex-col items-start justify-start">
            <div className="flex flex-row items-center channel-nav-title gap-[5px]">
              {icon ? <img src={icon} alt={subtitle} className="inline w-6 h-6 mr-1" /> : <></>}
              <span>{title}</span>
            </div>
            {subtitle || userActions ? (
              <span className="channel-nav-sub-title">
                {/* {icon ? <img src={icon} alt={subtitle} className="inline w-4 h-4 mr-1" /> : <></>} */}
                {subtitle}
                {userActions ? <span className="text-black ">{userActions}</span> : <></>}
              </span>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="flex flex-row items-end float-right gap-[15px] pr-2 align-middle md:pr-0">
          <>
            {onSearch && (
              <button onClick={() => {}} className="text-sm text-gray-800 bg-white rounded-full md:m-0" aria-label="Options">
                <img src={`/icons/Search.png`} alt="Search" className="w-6 h-6 min-w-6 min-h-6" />
              </button>
            )}
            {/* {onClose && (
              <button
                className={
                  (enableLink ? " bg-white " : " bg-gray-400  disabled-link ") +
                  "flex items-center justify-center px-3 py-1 text-sm font-normal text-center border-skgray border-[1px] text-black rounded-lg"
                }
                onClick={onClose}
              >
                Close
              </button>
            )} */}
            {FilterButton}

            {getActionItems && (
              <ActionPopup
                className="col-span-1 "
                getValues={() => getActionItems()}
                onSelect={actionItem => onActionItemSelect && onActionItemSelect(actionItem)}
                align="right"
              />
            )}
            {onFilter && (
              <button onClick={onFilter} className="text-sm text-gray-800 bg-white rounded-full md:m-0" aria-label="Options">
                <img src={`/icons/Options.png`} alt="Close" className="w-6 h-6 min-w-6 min-h-6" />
              </button>
            )}
            {onClose && (
              <button className="flex text-black border-gray-400 channel-nav-btn" onClick={onClose}>
                Close
              </button>
            )}
            {onEdit && (
              <button className="flex text-black border-gray-400 channel-nav-btn" onClick={onEdit}>
                Edit
              </button>
            )}
            {onNext && (
              <button
                className={(enableLink ? "flex bg-black " : " bg-bordergray disabled-link ") + "flex text-white channel-nav-btn"}
                onClick={onNext}
              >
                {buttonTitle}
              </button>
            )}
          </>
        </div>
      </div>
      <div>
        <div className=" thickseparator"></div>
      </div>
    </>
  );
};

export default ContainerNavigation;
